export const UPDATE_REQUESTS = "UPDATE_REQUESTS";

export const updateRequests = (value) => ({
  type: UPDATE_REQUESTS,
  value,
});
